import { MoneyBox, NumberBoxLayoutStyle } from '@apply/components';
import { useStandardLoanStore } from '../../../../../../../state/standardLoanStore';
import { toPositiveNumber } from './functions/toPositiveNumber';

export const UnderwritingFeeField = () => {
    const value = useStandardLoanStore((state) => state.loan.underwritingFee);
    const updateLoan = useStandardLoanStore((state) => state.updateLoan);

    return (
        <MoneyBox
            id='loanUnderwritingFee'
            value={value}
            onChange={(amount) => updateLoan({ underwritingFee: toPositiveNumber(amount) })}
            label='Underwriting Fee'
            displayChange={true}
            width='100%'
            height='36px'
            layoutStyle={NumberBoxLayoutStyle.Horizontal}
            labelWidth='150px'
        />
    );
};
